/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: BaseEnv.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Tasks/Badge.ts;
 * Description: Copia di presenze ma associate a persone e con la gestione dei record degli accessi (badge elettronici /orari);
 * Author: giovannibattistadellaporta;
 * Created at: 20/03/24, 11:28;
 * Updated at: 20/03/24, 11:28;
 *
 *
 */

import { ToastrService } from "ngx-toastr";
import { ApiPathsService } from "src/app/api-paths.service";

export const Badge = () => {
    return {
        type: 'K',
        addButton: true,
        managerLoggato: {},
        hideif: { hasNotCapacity: [] },
        restRoute: '/anagrafica/persone/badge',
        Label: '',
        Headers: [
            //{nome: "N.", oggetti: ["id"]},
            { nome: "Stato", oggetti: ['stato'], inputType: 'text' },
            { nome: "Data", oggetti: ['data_inizio_prevista'], inputType: 'datetime-local' },
        ],
        Azioni: [{
            nome: 'Elimina',
            close: true,
            class: ' btn ',
            labelClass: 'ml-1 text-danger font-weight-bold',
            type: 'POST',
            restRoute: '/anagrafica/persone/badge/delete',
            preAlert: 'Sei sicuro di voler eliminare questo elemento?',
            icon: 'fas fa-trash text-danger',
            hideif: { fieldnotexist: 'id' },
            placeholder: 'Elimina',
            successMex: 'Elemento eliminato con successo',
            parameter: [{ nome: "id", parameter: 'id' }]
        }],
        legenda: {
            area: 'Legenda Presenze',
            legenda: [
                { label: 'Entrata', color: '#ff0000' },
                { label: 'Lavorato', color: '#00ff00' },
                { label: 'Ferie/Malattia/Festivo', color: 'blue' },
                { label: 'Permesso/Straordinario/104/CIGO', color: '#ffa500' },
            ],
        },
        campi: [
            {
                nome: 'Data',
                oggetti: ['data_attivita'],
                modificabile: true,
                inputType: 'datetime-local',
                class: "col-lg-6",
                required: true
            },
            {
                nome: 'Dipendente',
                source: '/anagrafica/persone/list',
                parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }, { nome: "ruolo", value: 'OP' }],
                oggetti: ['manager'],
                internalOutput: 'managerObject',
                responseHasData: true,
                OutputField: 'manager',
                OnChange: 'managerchange',
                modificabile: true,
                inputType: 'singleDropdown',
                placeholder: 'Seleziona un Dipendente',
                settings: {
                    singleSelection: true,
                    closeDropDownOnSelection: true,
                    singleOutput: true,
                    idField: 'id',
                    textField: 'fullName',
                    searchPlaceholderText: "Cerca",
                    allowSearchFilter: false,
                    allowRemoteDataSearch: false,
                },
                class: 'col-lg-6',
                visibleifProhibited: true
            },
            {
                nome: 'Ordinario',
                oggetti: ['ordinario'],
                modificabile: true,
                inputType: 'number',
                class: "col-3",
                required: false
            },
            {
                nome: 'Straordinario',
                oggetti: ['straordinario'],
                modificabile: true,
                inputType: 'number',
                class: "col-3",
                required: false
            },
            {
                nome: 'ROL',
                oggetti: ['rol'],
                modificabile: true,
                inputType: 'number',
                class: "col-3",
                required: false
            },
            {
                nome: 'Legge 104',
                oggetti: ['legge104'],
                modificabile: true,
                inputType: 'number',
                class: "col-3",
                required: false
            },
            {
                nome: 'Cassa integrazione',
                oggetti: ['cassa'],
                modificabile: true,
                inputType: 'number',
                class: "col-auto",
                required: false
            },
            {
                nome: 'Ferie',
                oggetti: ['ferie'],
                modificabile: true,
                inputType: 'checkbox',
                class: "col-auto",
                required: false
            },
            {
                nome: 'Malattia',
                oggetti: ['malattia'],
                modificabile: true,
                inputType: 'checkbox',
                class: "col-auto",
                required: false
            },
            {
                nome: 'Festivo',
                oggetti: ['festivo'],
                modificabile: true,
                inputType: 'checkbox',
                class: "col-auto",
                required: false
            },
            {
                nome: 'Timbratura',
                oggetti: ['figli'],
                modificabile: true,
                type: 'table',
                header: [

                    { nome: "Entrata", oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'datetime-local', class: 'col-lg-12' },
                    { nome: "Uscita", oggetti: ['data_fine_prevista'], modificabile: true, inputType: 'datetime-local', class: 'col-lg-12' },
                    { nome: "Note", oggetti: ['note'], modificabile: true, inputType: 'text', class: 'col-lg-12' },
                ],
                AzioniTask: [
                    {
                        nome: '',
                        close: false,
                        icon: 'fas fa-plus text-info',
                        class: ' btn ',
                        labelClass: 'text-info font-weight-bold',
                        type: 'func',
                        hideif: {
                            func: (x) => {
                                return true;
                            }
                        },
                        func: (task, api, endFunc) => {
                            debugger;
                            task.figli = task?.figli ?? [];
                            let id = Math.floor(Math.random() * 101);
                            while (task.figli.findIndex(x => x.id == id) > -1) {
                                id = Math.floor(Math.random() * 101);
                            }
                            let data = task.data_inizio_prevista.substring(0, 11) +  new Date().toLocaleString().substring(12, 17);
                            task.figli.push({ id: id, data_inizio_prevista: data, data_fine_prevista: '', note: '' })
                        },
                        validate: (item: any, Toastr: ToastrService, api: ApiPathsService) => {
                            return true
                        },
                    },
                ],
                azioni: [
                    {
                        type: 'func',
                        func: (task, api, endFunc) => {
                            let index = task.figli.findIndex(x => x.id == task.id);
                            task.figli.splice(index, 1);
                        },
                        icon: 'fa-trash',
                        tooltip: 'Elimina',
                        color: 'red'
                    }
                ],
                class: 'col-lg-12'
              },
        ]
    };
}